import { createSlice } from "@reduxjs/toolkit";
import { getWalkthroughList } from "../../reduxApi/admin/WalkthroughReduxApi";

const walkSlice = createSlice({
    name: 'walk',
    initialState: {
        status: 'idel',
        isFiltered: false,
        walk: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteWalkAction: (state, action) => {
            console.log("action.payload",action.payload);
            
            action.payload.forEach((id) => {
                const index = state.walk.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.walk.splice(index, 1);
                }
            });
        },
        updateWalkAction: (state, action) => {
            const index = state.walk.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.walk.splice(index, 1, { walks: action.payload })
            }
        },
        addWalkAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.walk.unshift({ walks: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getWalkthroughList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getWalkthroughList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.walk = action.payload.data.walkthroughs;
            })
    }
})
export const { deleteWalkAction, updateWalkAction, addWalkAction, setFilteredStatus } = walkSlice.actions
export default walkSlice.reducer